import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { BREAK_POINTS } from '@constants/common/breakpoints';

type StyledPaginationContainerProps = PropsWithChildren;

export const StyledPaginationContainer = styled.div<StyledPaginationContainerProps>`
    display: grid;
    gap: 16px;
    max-width: 100%;
    position: relative;
    margin: auto;
    align-items: center;
    justify-items: center;

    /* Mobile: stack items */
    grid-template-columns: 1fr;

    @media (${BREAK_POINTS.xs} <= width < ${BREAK_POINTS.md}) {
        grid-template-columns: repeat(2, 1fr);

        & > *:nth-child(1) {
            justify-self: start;
        }
        & > *:nth-child(2) {
            order: 3;
            grid-column: span 2;
            justify-self: center;
        }
        & > *:nth-child(3) {
            justify-self: end;
        }
    }

    @media (width >= ${BREAK_POINTS.md}) {
        /* Desktop: three columns */
        grid-template-columns: repeat(3, 1fr);

        & > *:nth-child(1) {
            justify-self: start;
        }
        & > *:nth-child(2) {
            justify-self: center;
        }
        & > *:nth-child(3) {
            justify-self: end;
        }
    }
`;
